;(function ($, window, document) {
    /* ------------------------------------------- */
    /* SWIPER */
    /* ------------------------------------------- */

    const reviewSliderSettings = { // global keyboard accessibility settings for review sliders
        watchSlidesProgress: true, // adds swiper-slide-fully-visible, used for link tab stops and announcements
        roundLengths: true, // whole-pixel slide widths, fractional ones made Swiper treat the last visible slide as cut off
        a11y: {
            containerRole: 'region',
            containerRoleDescriptionMessage: 'carousel',
            containerMessage: 'Reviews',
            slideLabelMessage: 'Review {{index}} of {{slidesLength}}',
            prevSlideMessage: 'Previous reviews',
            nextSlideMessage: 'Next reviews',
        },
    };

    // old manual reviews
    const testimonialsThumb = new Swiper('.js-testimonials-thumb', {
        slidesPerView: 1,
        loop: true,
        loopedSlides: 1,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
    });

    const testimonialsMain = new Swiper('.js-testimonials-main', {
        loop: true,
        loopedSlides: 1,
        autoplay: {
            delay: 3500,
        },
        navigation: {
          nextEl: '.js-testimonials-main--next',
          prevEl: '.js-testimonials-main--prev',
        },
        thumbs: {
          swiper: testimonialsThumb
        },
    });

    // home page company reviews
    const testimonialsHome = new Swiper('.js-testimonials-home', {
        ...reviewSliderSettings,
        loop: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 1000,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        roundLengths: true,
        autoplay: {
            delay: 3500,
        },
        navigation: {
          nextEl: '.js-testimonials-home--next',
          prevEl: '.js-testimonials-home--prev',
        },
    });

    //branch and state reviews
    const branchReview = new Swiper('.js-branch-review', {
        ...reviewSliderSettings,
        loop: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loopAddBlankSlides: false,
        spaceBetween: 30,
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            1200: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            }
        },
        navigation: {
          nextEl: '.js-branch-review-next',
          prevEl: '.js-branch-review-prev',
        }
    });

    // LO CPT reviews
    const loReview = new Swiper('.js-lo-review', {
        ...reviewSliderSettings,
        loop: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loopAddBlankSlides: false,
        spaceBetween: 30,
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            1200: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            1500: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            }
        },
        navigation: {
          nextEl: '.js-lo-review-next',
          prevEl: '.js-lo-review-prev',
        }
    });

    // LO ACF reviews
    const singleLoReview = new Swiper('.js-single-review', {
        ...reviewSliderSettings,
        loop: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loopAddBlankSlides: false,
        spaceBetween: 30,
        autoplay: {
            delay: 5000,
        },
        navigation: {
          nextEl: '.js-single-review-next',
          prevEl: '.js-single-review-prev',
        }
    });

    // columns-slider horizontal and vertical
    $('.js-columns-slider-horizontal').each(function() {
        const swiper = new Swiper(this, {
            loop: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            spaceBetween: 20,
            autoplay: {
                delay: 3500,
            },
        });
    });

    $('.js-columns-slider-vertical').each(function() {
        const swiper = new Swiper(this, {
            loop: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            direction: 'vertical',
            spaceBetween: 20,
            watchSlidesProgress: true,
            autoplay: {
                delay: 3500,
            },
        });
    });

    // LO qualifier logos slider - only on mobile
    if ($('.js-logo-slider').length) {
        const logoSliderSettings = {
            slidesPerView: 2,
            loop: true,
            spaceBetween: 20,
            autoplay: {
                delay: 5000,
            },
            breakpoints: {
                575: {
                    slidesPerView: 3,
                }
            }
        }

        let init = false;
        let logoSlider;

        function logoSliderReset() {
            if (window.innerWidth < 768) {
                if (!init) {
                    init = true;
                    logoSlider = new Swiper('.js-logo-slider', logoSliderSettings)
                }
            } else if (init) {
                logoSlider.destroy();
                init = false;
            }
        }

        logoSliderReset();

        // reset logo slider on window resize
        let _windowWidth = $(window).outerWidth();

        $(window).on('resize', debounce(() => {
            const currentWidth = $(window).outerWidth();
            if (currentWidth !== _windowWidth) { // avoid unnecessary resets when only height changes
                _windowWidth = currentWidth;
                logoSliderReset();
            }
        }, 100));

        function debounce(fn, delay) {
            let timer;
            return function() {
                clearTimeout(timer);
                timer = setTimeout(fn, delay);
            };
        }
    }

    // media slider with videos
    $('.js-media-slider').each(function() {
        const $slider = $(this);

        const mediaSlider = new Swiper(this, {
            slidesPerView: 1,
            centeredSlides: true,
            loop: true,
            initialSlide: 1, // focus on second slide
            noSwiping: true,
            noSwipingClass: 'swiper-no-swiping',
            breakpoints: {
                992: {
                    slidesPerView: 3,
                }
            },
            navigation: {
                nextEl: $slider.find('.js-media-slider--next')[0],
                prevEl: $slider.find('.js-media-slider--prev')[0],
            },
        });

        mediaSlider.on('slideChangeTransitionEnd', function(slider) {
            pauseNonCenteredVideos(slider);
        });
    });

    /* ------------------------------------------- */
    /* HELPERS */
    /* ------------------------------------------- */

    // Pause videos not centered by removing autoplay param
    function pauseNonCenteredVideos(slider) {
        $(slider.slides).each(function() {
            const slide = $(this);
            const iframe = slide.find('iframe');

            if (iframe.length === 0) return;

            const isActive = slide.hasClass('swiper-slide-active');
            const src = iframe.attr('src');

            if (!isActive && src && src.includes('?autoplay=1')) {
                iframe.attr('src', src.replace('?autoplay=1', ''));
            }
        });
    }

    // show "read more" only on branch/state/LO reviews cut off by -webkit-line-clamp (see branch-reviews.scss and lo-reviews.scss)
    const updateReviewClamp = function (blockquote) {
        const reviewText = blockquote.closest('.review-text');
        const isClamped  = blockquote.scrollHeight > blockquote.clientHeight + 1; // +1 for sub-pixel rounding

        // never hide a focused link, or keyboard focus jumps back to the top of the page
        if (!isClamped && reviewText.contains(document.activeElement)) return;

        reviewText.classList.toggle('is-clamped', isClamped);
    };

    const reviewQuotes = document.querySelectorAll('.review-text blockquote');

    if (reviewQuotes.length && 'ResizeObserver' in window) {
        // fires once on observe, then whenever a review's size changes (resize, zoom, breakpoints)
        const reviewClampObserver = new ResizeObserver(function (entries) {
            entries.forEach(function (entry) { updateReviewClamp(entry.target); });
        });
        reviewQuotes.forEach(function (blockquote) { reviewClampObserver.observe(blockquote); });

        // web fonts can change line breaks without changing a clamped review's size
        document.fonts.ready.then(function () { reviewQuotes.forEach(updateReviewClamp); });
    }

    /* ------------------------------------------- */
    /* REVIEW SLIDERS KEYBOARD/SCREEN READER */
    /* ------------------------------------------- */
    // tab stops: the slider (arrows change slides), links in fully visible slides, then the prev/next buttons

    const initReviewSliderA11y = function (swiper) {
        // slider not on this page, or a single review without a slider
        if (!swiper || !swiper.initialized) return;

        const container = swiper.el;
        container.setAttribute('tabindex', '0');
        swiper.wrapperEl.setAttribute('aria-live', 'off'); // Swiper's default would read every visible review on each change

        // short "Reviews 4, 5 and 6 of 12" message instead
        const status = document.createElement('span');
        status.setAttribute('aria-live', 'polite');
        status.style.cssText = 'position: absolute; width: 1px; height: 1px; overflow: hidden; clip-path: inset(50%); white-space: nowrap;';
        container.appendChild(status);

        const getVisibleSlides = function () {
            return swiper.slides.filter(function (slide) {
                return slide.classList.contains('swiper-slide-fully-visible');
            });
        };

        // links in slides out of view are skipped by tab, but still reachable by screen readers
        const syncLinkTabStops = function () {
            const visibleSlides = getVisibleSlides();

            swiper.slides.forEach(function (slide) {
                const isVisible = visibleSlides.includes(slide);
                slide.querySelectorAll('a[href]').forEach(function (link) {
                    if (isVisible) link.removeAttribute('tabindex');
                    else link.setAttribute('tabindex', '-1');
                });
            });
        };

        const announceVisibleSlides = function () {
            const active = document.activeElement;
            const navEls = [].concat(swiper.navigation.prevEl || [], swiper.navigation.nextEl || []);
            if (!active || (!container.contains(active) && !navEls.includes(active))) return; // only while using the slider

            const positions = getVisibleSlides().map(function (slide) {
                return Number(slide.getAttribute('data-swiper-slide-index')) + 1; // loop mode reorders slides, use the original index
            });
            if (!positions.length) return;

            const last = positions.pop();
            const list = positions.length ? positions.join(', ') + ' and ' + last : last;
            status.textContent = (positions.length ? 'Reviews ' : 'Review ') + list + ' of ' + swiper.slides.length;
        };

        // wait a frame so Swiper has updated the visibility classes
        const onSlidesMoved = function () {
            requestAnimationFrame(function () {
                syncLinkTabStops();
                announceVisibleSlides();
            });
        };

        swiper.on('transitionEnd resize breakpoint', onSlidesMoved);
        onSlidesMoved();

        container.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
            if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return; // keep browser shortcuts like Alt+Left (back)

            e.preventDefault();
            if (e.target.closest('.swiper-slide')) container.focus(); // the focused link may slide out of view

            if (e.key === 'ArrowLeft') swiper.slidePrev();
            else swiper.slideNext();
        });
    };

    // Swiper returns an array when a selector matches more than one slider on the page
    [testimonialsHome, branchReview, loReview, singleLoReview].flat().forEach(initReviewSliderA11y);
})(jQuery, window, document);
